import {
    DECREASEQTY,
    INCREASEQTY,
    PRODUCTADD,
    PRODUCTDELETED
} from "./ActionType";

export const addNewProduct = (product) => {
  return {
    type: PRODUCTADD,
    payload: product,
  };
};

export const increaseCurrentQTY = (id) => {
  return {
    type: INCREASEQTY,
    payload: id,
  };
};

export const decreaseCurrentQTY = (id) => {
  return {
    type: DECREASEQTY,
    payload: id,
  };
};

export const productDeleted = (id) => {
  return {
    type: PRODUCTDELETED,
    payload: id,
  };
};
